import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchContactUsTable } from "../../api/contactUsApi";
import { sendReplyQuery } from "../../api/contactUsApi"; // Import the function

export const getContactUs = createAsyncThunk(
  "roomType/getContactUs",
  //  @ts-ignore
  async ({ page, limit }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchContactUsTable(page, limit);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const sendReply = createAsyncThunk(
  "contactUs/sendReply",
  async (data: {  message: string,id:string }, { rejectWithValue }) => {
    try {
      return await sendReplyQuery(data);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const contactUsSlice = createSlice({
  name: "contactUs",
  initialState: {
    contacts: [] as any[],
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
    replyStatus: null as boolean | null, // State for sendReply
    replyError: null as string | null, // Error for sendReply
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        getContactUs.fulfilled,
        (state, action: PayloadAction<any[]>) => {
          state.status = true;
          state.contacts = action.payload;
        }
      )
      .addCase(getContactUs.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      .addCase(sendReply.fulfilled, (state) => {
        state.replyStatus = true;
        state.replyError = null;
      })
      .addCase(sendReply.rejected, (state, action) => {
        state.replyStatus = false;
        state.replyError = action.payload as string;
      });
  },
});

export const { resetStatus } = contactUsSlice.actions;
export default contactUsSlice.reducer;
